<template>
  <div class="feed-item triple-imgs" data-spm-type="resource">
    <a :href="feedData.url" target="_blank" class="feed-item__box" :data-mphref="feedData.personalPage">
      <div class="feed-item__left img-do">
        <div class="img-left">
          <img :src="feedData.images[0]" alt="配图" />
        </div>
        <div class="img-right">
          <div class="img-right__item1">
            <img :src="feedData.images[1]" alt="配图" />
          </div>

          <div class="img-right__item2">
            <img :src="feedData.images[2]" alt="配图" />
            <span class="img-right__cover">{{ feedData.imageNum }} 图</span>
          </div>
        </div>
      </div>

      <div class="feed-item__right">
        <p class="atlas-flag">
          <span><i class="atlas-icon"></i> 图集</span>
        </p>
        <h5 class="feed-item__title">{{ feedData.title }}</h5>
        <div class="feed-item__footer">
          <a class="auther-box" :href="feedData.personalPage">
            <img class="auther-img" :src="feedData.authorPic" alt="作者头像" />
            <span class="auther__name">{{ feedData.authorName }}</span>
          </a>
          <span class="time">{{ feedData.fixTime }}</span>
        </div>
      </div>
    </a>
    <div style="clear: both"></div>
  </div>
</template>

<script>
export default {
  props: {
    feedData: {
      type: Object,
      required: true,
      default: () => ({
        url: '',
        personalPage: '',
        title: '',
        images: ['', '', ''],
        imageNum: 0,
        authorPic: '',
        authorName: '',
        fixTime: '',
      }),
    },
  },
  data() {
    return {
    };
  },
};
</script>

<style scoped>

</style>
